/** PURE_IMPORTS_START ._BoundNodeCallbackObservable PURE_IMPORTS_END */
import { BoundNodeCallbackObservable } from './BoundNodeCallbackObservable';
export var bindNodeCallback = BoundNodeCallbackObservable.create;
//# sourceMappingURL=bindNodeCallback.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/observable/bindNodeCallback.js
// module id = 762
// module chunks = 0